export const BASE64 = {
  csv: 'data:text/csv;charset=utf-8;base64,',
  zip: 'data:application/zip;base64,',
  pdf: 'data:application/pdf;base64,',
};
